module.exports = __webpack_public_path__ + "img/wa09.281d55d7.jpg";